exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-truncate[data-v-0b032790] {\n  padding-top: 0.25rem;\n}", ""]);

// exports
